import { h, render, Component } from 'preact';
import './marker.scss';

export default class Marker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            trackLoading: false,
            trackShown: false
        };
    }

    _getImageStatusMarkup(status) {
        return { __html: fmtools.getStatusObjectIcon(status)}
    }

    _onTrackIconClick = (event) => {
        event.stopPropagation();
        let objectId = this.props.marker.id;

        if (this.state.trackShown) {
            this.props.removeTrack(objectId);
            this.setState({ trackShown: false });
            return;
        }

        this.setState({ trackLoading: true });
        this.props.addTrack(objectId).then(result => {
            if (result) {
                this.setState({
                    trackShown: true,
                    trackLoading: false
                });
            }
            else {
                this.setState({ trackLoading: false });
            }
        })
    };

    render (props, state) {
        let isTrackOnMap = state.trackShown;
        let trackIconTitle = isTrackOnMap
            ? fmtools.translate('RemoveTrack')
            : fmtools.translate('RequestTrack');
        let trackIconColor = isTrackOnMap ? '#11a8d3' : 'grey';

        return (
            <div class={props.active?"marker-item marker-item-active":"marker-item"} 
                 onClick={props.onClick}>
                <img src={`../icons/objects/${props.marker.obj_icon}`} class="marker-item-icon"/>
                <span class="marker-item-content">{props.marker.name}</span>
                <span class="marker-item-status">
                    <div dangerouslySetInnerHTML={this._getImageStatusMarkup(props.marker.move)} />
                </span>
                {
                    props.allowTrack && this.state.trackLoading &&
                    <div class="marker-track-loading-icon" />
                }
                {
                    props.allowTrack && !this.state.trackLoading &&
                    <span title={trackIconTitle} class="marker-item-status" onClick={this._onTrackIconClick}>
                        <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                            <path fill={trackIconColor} d="M18,11H14.82C14.4,9.84 13.3,9 12,9C10.7,9 9.6,9.84 9.18,11H6C5.67,11 4,10.9 4,9V8C4,6.17 5.54,6 6,6H16.18C16.6,7.16 17.7,8 19,8A3,3 0 0,0 22,5A3,3 0 0,0 19,2C17.7,2 16.6,2.84 16.18,4H6C4.39,4 2,5.06 2,8V9C2,11.94 4.39,13 6,13H9.18C9.6,14.16 10.7,15 12,15C13.3,15 14.4,14.16 14.82,13H18C18.33,13 20,13.1 20,15V16C20,17.83 18.46,18 18,18H7.82C7.4,16.84 6.3,16 5,16A3,3 0 0,0 2,19A3,3 0 0,0 5,22C6.3,22 7.4,21.16 7.82,20H18C19.61,20 22,18.93 22,16V15C22,12.07 19.61,11 18,11M19,4A1,1 0 0,1 20,5A1,1 0 0,1 19,6A1,1 0 0,1 18,5A1,1 0 0,1 19,4M5,20A1,1 0 0,1 4,19A1,1 0 0,1 5,18A1,1 0 0,1 6,19A1,1 0 0,1 5,20Z" />
                        </svg>
                    </span>
                }
            </div>
        );
    }
}